import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { DeleteButton } from '../../common/button';
import { ApiRequestStatusEnum } from '../../../core/enums/common/api';
import useNotification from '../../../core/hooks/use_notification';
import { getProducersState } from "../../../features/product/get_producers";
import { deleteProducerAction, deleteProducerState } from "../../../features/product/delete_producer";
import { GET_ROUTE_PRODUCER_FORMS } from "../../../core/constants";
import { deleteProducerNotificationData } from "../../../core/utils/notification_utils";

const ProducersList = ({ refreshList }) => {
    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getProducers = useSelector(getProducersState);
    const deleteProducer = useSelector(deleteProducerState);

    const onDeleteProducer = (producerId) => {
        dispatch(deleteProducerAction(producerId))
            .then(response => {
                showNotification(deleteProducerNotificationData(response));
                response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED && refreshList();
            });
    }

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell>Nazwa producenta</TableCell>
                        <TableCell align="center" sx={ { width: 120 } }></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        getProducers?.data?.content?.map(producer => (
                            <TableRow key={ producer?.id } hover>
                                <TableCell sx={ { fontWeight: 500 } }>{ producer?.name }</TableCell>
                                <TableCell align="center">
                                    <Stack direction="row" justifyContent="center" spacing={ 1 }>
                                        <IconButton
                                            color="primary"
                                            title="Edytuj producenta"
                                            size="small"
                                            onClick={ () => navigate(GET_ROUTE_PRODUCER_FORMS(producer?.id)) }
                                        >
                                            <EditIcon fontSize="small"/>
                                        </IconButton>
                                        <DeleteButton
                                            onDeleteClick={ () => onDeleteProducer(producer?.id) }
                                            isLoading={ deleteProducer?.loading }
                                        />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))
                    }

                    { (!getProducers?.data?.content || getProducers?.data?.content.length === 0) && (
                        <TableRow>
                            <TableCell colSpan={ 2 } align="center" sx={ { py: 4, color: 'text.secondary' } }>
                                Brak wyników do wyświetlenia.
                            </TableCell>
                        </TableRow>
                    ) }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ProducersList;